module.exports = __webpack_public_path__ + "static/media/userAdd.d7c5e74e.svg";